/* 机构-我的课程 */
import path from '@/api/index'
import { axios } from '@/utils/request'
import parsePageParams from "../../utils/page";


// 销课分页
export function queryList(data) {
    return axios({
        url: path.client + '/course/queryCourseList',
        method: 'POST',
        data: data,
        params: parsePageParams(data)
    })
}

// 销课记录分页
export function signDataList(data) {
    return axios({
        url: path.client + '/client/curriculumSignInfo/signDataList',
        method: 'POST',
        data: data,
        params: parsePageParams(data)
    })
}

// 机构H5-销课记录详情(单个)
export function signDetailInfo(params) {
    return axios({
        url: path.client + '/client/curriculumSignInfo/signDetailInfo',
        method: 'GET',
        params,
    })
}

// 机构H5-销课记录修改
export function signModify(data) {
    return axios({
        url: path.client + '/client/curriculumSignInfo/signModify',
        method: 'PUT',
        data: data,
    })
}

//获取详细信息
export function queryDetailInfo (params) {
    return axios({
        url: path.client + '/course/queryDetailInfo',
        method: 'GET',
        params: params
    })
}

//获取详细信息
export function signAdd (params) {
    return axios({
        url: path.client + '/client/curriculumSignInfo/signAdd',
        method: 'PUT',
        data: params
    })
}
